
import authorizationRoutes from 'components/common/authorization/routes';

import signUpRoutes from 'components/core/login/routes';
import stepsRoutes from 'components/core/steps/routes';

export default [].concat(
  authorizationRoutes,
  signUpRoutes,
  stepsRoutes,
);



// WEBPACK FOOTER //
// ./src/routes/RoutesAPI.js